import React, {useEffect, useState,useMemo} from "react";
import tempPhoto from '../../../assets/img/tempPhoto.svg';
import PaymentContainer from "../PaymentContainer";
import FakePaymentContainer from "../FakePaymentContainer";
import {selectProfileInfo, selectProfileLoading } from "../../../store/selectors/Profile";
import URLS from "../../../config/navigation";
import { getProfileInfo, getSelfProfileInfo } from "../../../store/entities/Profile/Profile.actions";
import {useDispatch, useSelector} from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import Avatar from '@material-ui/core/Avatar';
import {useHistory} from "react-router-dom";
import ParagraphText from '../../Common/Typography/paragraph'
import H2Text from '../../Common/Typography/h2'
import HelmetComponent from '../../Common/Helmet'
import { Helmet } from "react-helmet";
import { getToken } from "../../../utils";
import Loader from '../../Common/Loader/'

const UserProfile = (props) => {
  const token = getToken();
  const history = useHistory();
  const [profileUrl, setProfileUrl] = useState(null);
  const [payloading, setPayloading] = useState(false);
  const [paymentFlag, setPaymentFlag] = useState(false);
  const profileInfo = useSelector(selectProfileInfo);
  const loading = useSelector(selectProfileLoading);
  const dispatch = useDispatch();
  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
  }

const title = useMemo(()=>{
  let result ="TeachOn";
  if(token && props.match.url===URLS.PROFILE.DATA)
  {
    result ="My Profile - TeachOn";
  }
  else
  {
    if(profileInfo){
      let fname = capitalizeFirstLetter(profileInfo.firstName);
      let lname = capitalizeFirstLetter(profileInfo.secondName);
      result = fname+' '+lname+" - TeachOn";
    }
  }
  return result;
},[])



  const getSelfCallback = (response) => {
    console.log('getSelfCallback',response)
    if(!response.data.firstName ||  !response.data.secondName || !response.data.about){
      localStorage.setItem("onBoarding",true)
      history.push(URLS.PUBLIC.SETUP)
    }else if(!response.data.publicUrlName){
      localStorage.setItem("onBoarding",true)
      history.push(URLS.PUBLIC.LINK)
    } else if (!response.data.stripeAccountId) {
      localStorage.setItem("onBoarding",true)
      history.push(URLS.PUBLIC.PREVIEW_CONNECT_BANK_ACC)
    }

    if(response.data.stripeOnboardingLink) {
      window.location.href = response.data.stripeOnboardingLink;
    }
  }

  const errorCallback = (e) => {
    if(e.response.status === 404)
      history.push(URLS.AUTH.SIGNIN)
  }

  useEffect(() => {
    if (props.match.path === URLS.PUBLIC_ROOT) {
      if(token){
        let elm =  document.getElementsByClassName("bottomNavigation");
        if(typeof elm!==undefined){

          elm[0].style.display='none';
        }
        setPaymentFlag(true)
      }

      setProfileUrl(props.match.params.profileUrl);
      dispatch(getProfileInfo(props.match.params.profileUrl, errorCallback))
    } else {
      dispatch(getSelfProfileInfo(getSelfCallback))
    }
  }, [])

  const renderProfileInfo = () => {
    return (
      <>
      <Helmet>
        <title>{profileInfo.firstName + ' ' + profileInfo.secondName + ' - TeachOn'}</title>
      </Helmet>
        <Avatar
          className={"userPhoto"}
          src={ profileInfo.avatar ? profileInfo.avatar : tempPhoto}
          alt="User photo"
        />
        {/* <OutlineButton text={"Contact"} handleClick={handleContact}  ></OutlineButton> */}
         <H2Text text={profileInfo.firstName+' '+profileInfo.secondName} addClass={"userName H2"}>

        </H2Text>
       {/* p */}
        { profileInfo.about && (<ParagraphText text= {profileInfo.about} addClass="user" />)}
        {token ?
            (paymentFlag ?
            (
                <PaymentContainer handleLoading={handleLoading} token={token} profileUrl={profileUrl}/>
            )
            :
            (
                <FakePaymentContainer token={token} profileUrl={profileUrl}/>
            ))
            :
            (
                <PaymentContainer handleLoading={handleLoading} token={token} profileUrl={profileUrl}/>
            )}
      </>
    )
  }



  const handleLoading = (val) => {
      setPayloading(val)
  }


  return (
    <>
      <div className={"userProfileContainer"}>
       {payloading && <Loader /> }
        <div className={"inner"}>
          {
            loading ?
              (
                <div className={"loaderContainer"}>
                  <CircularProgress className="loader" />
                </div>
                )
              : renderProfileInfo()
          }
        </div>
      </div>
    </>
  );
}

export default UserProfile;
